export const camelCaseToRegularCase = (string: string) => {
    return (
        string?.replace(/([A-Z])/g, " $1")?.[0]?.toUpperCase() +
            string?.replace(/([A-Z])/g, " $1")?.slice(1) ?? ""
    );
};
